import React, {useState} from 'react'
import './Products.css';
import data from "../data/Images.json"
import Modal from './Modal';

const Products = () => {

    const [clickedImg, setClickedImg] = useState(null); 
    const handleClick = (item, index) => {
        setClickedImg(item.link);
    };



  return (
    <div className='services'>
        <h3><span>We offer everything from Time and Attendance Software to Welding Jobs and back to Security electronics.  You need it, we provide it!  Have a look at the range of products we supply.</span></h3>
        <h3><span>Contact Us.</span></h3>
            <div>
                <h2 className='padded'>Gate Motors</h2>
            </div>
            <div>
                <h2 className='padded'>NVRs</h2>
            </div>
            <div className='card-container'>
                {data.nvrs.map((item, index) => (
                    <div key={index} className="card">
                       <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>    
            <div>
                <h2 className='padded'>Dome Cameras</h2>
            </div>
            <div className='card-container'>
                {data.dome.map((item, index) => (
                    <div key={index} className="card">
                            <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>
            <div>
                <h2 className='padded'>Static Cameras</h2>
            </div>
            <div className='card-container'>
                {data.static.map((item, index) => (
                    <div key={index} className="card">
                        <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>
            <div>
                <h2 className='padded'>Sensors</h2>
            </div>
            <div className='card-container'>
                {data.sensors.map((item, index) => (
                    <div key={index} className="card">
                        <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>
            <div>
                <h2 className='padded'>Other Security</h2>
            </div>
            <div className='card-container'>
                {data.othersecurity.map((item, index) => (
                    <div key={index} className="card">
                        <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>
            <div>
                <h2 className='padded'>Security Specials</h2>
            </div>
            <div className='card-container1'>
                {data.securityspecials.map((item, index) => (
                    <div key={index} className="card">
                        <img src={item.link} alt={item.text} onClick={() => handleClick(item, index)}/>
                    </div>
                ))}
                {clickedImg && <Modal clickedImg={clickedImg} setClickedImg={setClickedImg}/>}
            </div>
            <div>
                <h2 className='padded'>Project Management</h2>
            </div>
            <div>
                <h2 className='padded'>Boom gates, Barriers, Electric Fencing and Turnstiles</h2>
            </div>
            <div>
                <h2 className='padded'>Biometrics</h2>
            </div>
            <div>
                <h2 className='padded'>Inverters and UPS's</h2>
            </div>
            <div>
                <h2 className='padded'>Maintenance</h2>
            </div>
            <div>
                <h2 className='padded'>Graphic and Website Design</h2>
                <h3><a  href="https://www.interstellar-designs.co.za">By Interstellar Designs</a></h3>
                </div>
        </div>
  )
}

export default Products

